import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { CollectionPaths } from '@models/collections';
import { Repo } from '@repos/repo.service';
import {
	BillingBusinessType,
	BillingBusinessTypeIds,
} from '@models/billingBusiness';

@Injectable({
	providedIn: 'root',
})
export class BillingDefaultsSubTypesRepoService extends Repo<
	BillingBusinessType,
	BillingBusinessTypeIds
> {
	override GetCollectionPath(pathParams: BillingBusinessTypeIds): string {
		return CollectionPaths.billingDefaults_subTypes(pathParams as string);
	}

	constructor(firestore: AngularFirestore) {
		super(firestore);
	}
}
